function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.5339 14.6972L16.3002 4.46346C15.8568 4.01999 15.1404 4.01999 14.6969 4.46346L4.46321 14.6972C4.01975 15.1406 4.01975 15.857 4.46321 16.3005L14.6969 26.5342C15.1404 26.9776 15.8568 26.9776 16.3002 26.5342L26.5339 16.3005C26.9774 15.8684 26.9774 15.152 26.5339 14.6972ZM17.767 18.3472V15.5045H13.2187V18.9157H10.9446V14.3674C10.9446 13.742 11.4563 13.2303 12.0816 13.2303H17.767V10.3876L21.7468 14.3674L17.767 18.3472Z",
  fill: "white"
});

function SvgDirectionsFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionsFill);
export default __webpack_public_path__ + "static/media/directions-fill.b07ef50b.svg";
export { ForwardRef as ReactComponent };